document.addEventListener('DOMContentLoaded', () => {
  const fileInput = document.querySelector('input[type="file"]');
  if (!fileInput) return;

  fileInput.addEventListener('change', (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const fileSizeInMB = convertByteToMB(file.size);
    const isXlsx = file.name.endsWith('.xlsx');
    if (fileSizeInMB > 10 && isXlsx) {
      exibe_mensagem_com_status(window.t('interface.validacao_arquivo_xlsx', { tamanho_arquivo: `${fileSizeInMB} MB` }), 'warning');
    }
  });
});

function convertByteToMB(bytes) {
  return (bytes / 1024 / 1024).toFixed(2);
}